export default {
  ringing: 'Incoming call',
  callConnected: 'Call connected',
} as const;
